import { defineStore } from 'pinia';

export interface UserLoginState {
  email: string;
  // pageLoadUrl tracks the initial page load URL
  pageLoadUrl: string;
  password: string;
  shouldRememberEmail: boolean;
  verifyEmailHash?: string;
  emailSubmitResult: Record<string, any>; // Store the result from submitEmail API
}

export default defineStore('userLogin', {
  // arrow function recommended for full type inference
  state: (): UserLoginState => ({
    email: '',
    pageLoadUrl: '',
    password: '',
    shouldRememberEmail: false,
    verifyEmailHash: '',
    emailSubmitResult: {},
  }),
});
